<template>
    <span class="employee-filter-option" :class="{'is-selected': selected && !heading, 'is-heading': heading}">
        <span v-if="!heading" class="employee-filter-option__check" aria-hidden="true"></span>
        <span class="employee-filter-option__label">{{ label }}</span>
        <span v-if="!heading && count !== null" class="employee-filter-option__count">{{ count }}</span>
    </span>
</template>

<script>
export default {
    name: 'EmployeeFilterOption',
    props: {
        label: {type: String, required: true},
        selected: {type: Boolean, default: false},
        heading: {type: Boolean, default: false},
        count: {type: Number, default: null}
    }
};
</script>

<style>
/* The skills menu is moved to body by vue-select. Keep these rules menu-specific. */
.employee-checklist-menu.vs__dropdown-menu,
.employee-checklist-select .vs__dropdown-menu {
    padding: 6px;
    border: 1px solid #dce5ed;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(36, 58, 78, 0.14);
    max-height: 340px;
    scrollbar-width: thin;
    scrollbar-color: #b9c8d5 transparent;
}
.employee-checklist-menu .vs__dropdown-option,
.employee-checklist-select .vs__dropdown-option {
    padding: 0;
    margin: 2px 0;
    border-radius: 6px;
    color: #30485d;
    background: transparent;
    white-space: normal;
}
.employee-checklist-menu .vs__dropdown-option--highlight,
.employee-checklist-select .vs__dropdown-option--highlight {
    color: #30485d;
    background: #f0f5f9;
}
.employee-checklist-menu .vs__dropdown-option--disabled,
.employee-checklist-select .vs__dropdown-option--disabled {
    background: transparent;
    cursor: default;
}
.employee-filter-option {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 6px;
    font-size: 0.875rem;
    line-height: 1.4;
    white-space: normal;
}
.employee-filter-option.is-selected {
    background: #eaf4fc;
    color: #185c91;
}
.vs__dropdown-option--highlight .employee-filter-option.is-selected {
    background: #dceefb;
}
.employee-filter-option__check {
    position: relative;
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    border: 1.5px solid #afbfcc;
    border-radius: 5px;
    background: #fff;
}
.is-selected > .employee-filter-option__check {
    border-color: #1976bd;
    background: #1976bd;
}
.is-selected > .employee-filter-option__check::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 5px;
    width: 5px;
    height: 9px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}
.employee-filter-option__label {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
}
.employee-filter-option__count {
    flex: 0 0 auto;
    min-width: 26px;
    padding: 1px 7px;
    border-radius: 10px;
    background: #edf1f5;
    color: #52677a;
    font-size: 0.75rem;
    font-variant-numeric: tabular-nums;
    text-align: center;
}
.is-selected > .employee-filter-option__count {
    background: #d5e9f8;
    color: #185c91;
}
.employee-filter-option.is-heading {
    margin-top: 8px;
    padding: 10px 10px 5px;
    border-top: 1px solid #e8eef3;
    border-radius: 0;
    color: #718092;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
</style>
